import React from 'react';
import utils from '../../utils';
import fetch from '../fetch';
import {Modal, message,Tag} from 'antd';
import moment from 'moment';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    {
        key:'$index', width: 30,
        label: '序号',
    },
    {
        key: 'objectName', width: 70,
        label: '教师名称'
    },
    {
        key: 'titles', width: 70,
        label: '现职称'
    },
    // {
    //     key: 'objectType',
    //     label: '诊改对象',
    //     render: (data) => {
    //         var objectType = JSON.parse(data)
    //         if(objectType==0){
    //             return '部门';
    //         }else if(objectType==0){
    //             return '职工';
    //         }else if(objectType==0){
    //             return '课程';
    //         }else if(objectType==0){
    //             return '班级';
    //         }else {
    //             return '未知类型';
    //         }
    //     } 
    // },
    {
        key: 'orgName', width: 100,
        label: '部门',
    },
    {
        key: 'targetName', width: 80,
        label: '诊改指标',
    },
    // {
    //     key: 'resultGrade',
    //     label: '等级',
    // },
    {
        key: 'resultScore', width: 40,
        label: '分数',
    },
    // {
    //     key: 'submitEmployeeName', width: 70,
    //     label: '录入人'
    // },
    {
        key: 'termName', width: 100,
        label: '学期'
    },
    {key:'submitTime', label: '正式提交日期', width: 90, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') : ""},
    {key:'resultState', label: '状态', width: 60, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>预提交</Tag>)},
    // {key:'resultState', label: '操作', width: 90,  
    // render:(d, callback) => (+d.resultState === 1 ? 
    // (d.backFlag === false ? "已提交" : <a href="javascript:;" 
    // className="undo-button" 
    // onClick={() => {
        
    //     Modal.confirm({
    //         title: '确定回退？',
    //         content: '回退后，需要重新提交。确定要回退吗？',
    //         okText:"确认",
    //         cancelText:"取消",
    //         onOk: () => {
    //             fetch.post('jszgevalresult/batch/back', [d.id])
    //             .then(response => {
    //                 if(response.code === 200) {
    //                     message.success("回退成功！");
    //                     callback();
    //                 }
    //             });
    //         },
    //         onCancel: () => {},
    //     });

    // }}>回退</a> ): <a href="javascript:;" 
    // className="sumbit-button"
    // onClick={() => {
    //     Modal.confirm({
    //         title: '确定正式提交？',
    //         content: '正式提交后，将不能修改。确定要正式提交吗？',
    //         okText:"确认",
    //         cancelText:"取消",
    //         onOk: () => {
    //             fetch.post('jszgevalresult/batch/submit', [d.id])
    //             .then(response => {
    //                 if(response.code === 200) {
    //                     message.success("提交成功！");
    //                     callback();
    //                 }
    //             });
    //         },
    //         onCancel: () => {},
    //     });
        
    // }}
    // >正式提交</a>)}
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('jszgevalresult/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code === 200) {
            return {
                data: response.payload.data,
                backFlag: response.payload.meta.extParams.backFlag,
                meta: response.payload.meta
            }
        }
    }).then(response => (
        Object.assign({
            result: (response.data.dataList || []).map(item => {
                return Object.assign(item, {
                    backFlag: response.backFlag
                })
            }),
            selects: (response.data.dataList || []).map(d => ({
                value: d.resultId + '-' + d.submitEmployeeId,
                checked: false,
            })),
            meta: response.meta,
            checked: false,
            total:response.data.total,
            pageIndex: response.data.pageNum,
            pageSize: response.data.pageSize,
            notify: (response.data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}

/**
 * @method batchSubmit
 * @return {promise}
 */
const batchSubmit = (callback) => {
    return fetch.post('jszgevalresult/batch/submit', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success("提交成功！");
            callback();
        }
    });
}

/**
 * @method batchBack
 * @return {promise}
 */
const batchBack = (callback) => {
    return fetch.post('jszgevalresult/batch/back', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }

        callback();
        return response;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('jszgevalresult/remove/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        callback();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

export default {
    setRefresh,
    onSelect,
    batchSubmit,
    batchBack,
    getSelection,
    columns,
    querySearch,
    remove,
    batchRemove,
}